import { TabsNav } from '@/shared/components/ui'
import { useT } from '@/shared/i18n'

/** Las pantallas de configuración, siempre a la vista. */
export function SettingsNav() {
  const t = useT()

  const items = [
    { to: '/settings/fases', label: t('settings.nav.phases') },
    { to: '/settings/estados-de-tarea', label: t('settings.nav.taskStatuses') },
    { to: '/settings/usuarios', label: t('settings.nav.users') },
    { to: '/settings/agentes', label: t('settings.nav.agents') },
  ]

  return <TabsNav items={items} label={t('settings.nav.label')} />
}
